"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollToElement;
function scrollToElement(node) {
  node.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}